import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-anmeldung-erstellen-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerAnmeldungErstellenAdminEffects {

    BenutzerAnmeldungErstellenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN),
        mergeMap((x: ac.PostBenutzerAnmeldungErstellenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerAnmeldungErstellenAdmin(x.benutzerRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerAnmeldungErstellenAdminErfolgreichAction(result, x.benutzerRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerAnmeldungErstellenAdminFehlerAction(error, x.benutzerRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
